export class AuthApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    /** The address a 403 from /api/me says was refused. */
    public readonly email?: string,
    /** Why a 403 from /api/me refused it: `not_set_up` (no row) or `deactivated`. */
    public readonly reason?: string,
  ) {
    super(message);
    this.name = 'AuthApiError';
  }
}
